import { PaginatedDataDTO } from '@bottega52/commons-pagination';
import { Button, createStyles, WithStyles } from '@material-ui/core';
import WarningIcon from '@material-ui/icons/Warning';
import { withStyles } from '@material-ui/styles';
import _ from 'lodash';
import 'moment/locale/it';
import qs from 'query-string';
import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as CustomerPlantDecoder from '../../codec/customerDomainDecoder';
import { ModalTypes } from '../../components/Modals/ModalTypes';
import ReduxLanguage from '../../components/ReduxLanguage';
import * as ActivationActions from '../../redux/activations/activations.actions';
import * as UserActions from '../../redux/user/user.actions';
import * as CreditsActions from '../../redux/credits/credits.actions';
import * as ModalsActions from '../../redux/modals/modals.actions';
import CustomerContractDetailsView from "../../components/Customers/CustomerContractDetailsView";
import * as SettingsActions from '../../redux/settings/settings.actions';
import { IState } from '../../redux/store';
import { ICustomerContractsRequestParamsDTO, ICustomerRequestParamsDTO, IOrderDirectionEnum } from '../../repository/jago/model/output/RequestParamsDTOs';
import AbilityProvider from '../../services/PermissionService/AbilityProvider';
import { PERMISSIONS } from '../../services/PermissionService/PermissionConstants';
import translations from '../../translations/i18next';
import { ICustomerContractInDTO } from '../../repository/jago/model/input/ICustomerContractInDTO';
import CustomerContractsTable from '../../components/Customers/CustomerContractsTable';
import { ICustomerContractServiceInDTO } from '../../repository/jago/model/input/ICustomerContractServiceInDTO';
import { ICustomerContractSearchDTO } from '../../repository/jago/model/input/ICustomerContractSearchDTO';
import CustomerContractsSearchBar from '../../components/SearchBar/CustomerContractsSearchBar';
import moment from 'moment';
import { IWalletInDTO } from '../../repository/jago/model/input/IWalletInDTO';
import { ICustomerDomainFormDTO, IDomainInDTO } from '../../repository/jago/model/input/IDomainInDTO';
import CustomerPlantForm from '../../components/Forms/CustomerPlantForm';
import { ICustomerInDTO } from '../../repository/jago/model/input/ICustomerInDTO';
import WalletDetailsPage from '../../components/Wallets/WalletDetailsPage';
import { IWalletDetailedDTO } from '../../repository/jago/model/input/IWalletDetailedDTO';
import WalletForm from '../../components/Forms/WalletForm';
import { IWalletFormDTO } from '../../repository/jago/model/input/IWalletFormDTO';
import CustomerContractForm from '../../components/Forms/CustomerContractForm';
import { ICustomerContractFormDTO } from '../../repository/jago/model/input/ICustomerContractFormDTO';
import { getCustomersOptions } from '../../repository/utils';
import { ICustomerOptionDTO } from '../../repository/jago/model/input/ICustomerOptionDTO';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const styles = createStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
  text: {
    margin: 0,
    marginBottom: 15,
  },
  innerHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: 'white',
    zIndex: 200,
    padding: 10,
    paddingRight: 20,
    borderBottom: '2px solid #5AC0B1',
  },
  tableContainer: {
    display: 'flex',
    backgroundColor: 'white',
    height: 'calc(100vh - 160px)',
    width: '100%'
  },
});
export interface ICustomerContractsPageState {
  rowsPerPage: number;
  isLoading: boolean;
  filters: ICustomerContractSearchDTO;
  customersOptions: ICustomerOptionDTO[];
}

type IReduxProps = ConnectedProps<typeof connector> & RouteComponentProps<any>;

export interface ICustomerContractsPageProps extends WithStyles<typeof styles> {
  language: string;
  customerContracts: PaginatedDataDTO<ICustomerContractInDTO>;
}

export type ComponentProps = ICustomerContractsPageProps & IReduxProps;

class CustomerContractsPage extends React.Component<ComponentProps, ICustomerContractsPageState> {
  
  constructor(props: ComponentProps) {
    super(props);
    this.state = {
      isLoading: false,
      rowsPerPage: 50,
      customersOptions: [],
      filters: {
        search: '',
        status: '',
      }
    }
  }

  public async componentDidMount() {
    const { dispatch, history } = this.props;
    const { rowsPerPage } = this.state;
    const parsed = qs.parse(history.location.search);
    this.setState({ isLoading: true });
    try {
      const promises = [
        dispatch<any>(CreditsActions.fetchAllCustomerContracts({ page: 0, pageSize: rowsPerPage })),
        dispatch<any>(CreditsActions.fetchAllCustomerContractServices({ page: 0, pageSize: 10000 })),
      ]
      await Promise.all(promises);
      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
    }
    if (parsed && parsed.contractId) {
      const contractId = Number(parsed.contractId);
      const contracts = (this.props.customerContracts as PaginatedDataDTO<ICustomerContractInDTO>)?.content || [];
      const contract = contracts.find(c => c.id === contractId);
      if (contract) {
        this.onRowClick(contract);
      }
    }
  }

  async onFetchCustomerContracts(page: number = 0, pageSize: number = 100) {
    const { dispatch } = this.props;
    const { filters } = this.state;
    try {
      const params: ICustomerContractsRequestParamsDTO = { page, pageSize, ...filters };
      this.setState({ isLoading: true });
      await dispatch<any>(CreditsActions.fetchAllCustomerContracts(params));
      this.setState({ isLoading: false });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  }

  public onDeleteCustomerContractRequest(customerContractData: ICustomerContractInDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`DELETE_CUSTOMER_CONTRACT_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'credits.deleteCustomerContract',
        successMessageKey: 'credits.deleteCustomerContractConfirm',
        confirmMessageKey: 'forms.confirm',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.onDeleteCustomerContractConfirm(customerContractData),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`DELETE_CUSTOMER_CONTRACT_CONFIRM_MODAL`)),
      }
    }));
  }

  public async onDeleteCustomerContractConfirm(customerContractData: ICustomerContractInDTO) {
    const { dispatch, selectedCustomer } = this.props;
    const { rowsPerPage } = this.state;
    try {
      dispatch<any>(ModalsActions.hideModal(`DELETE_CUSTOMER_CONTRACT_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      await dispatch<any>(CreditsActions.deleteCustomerContract(selectedCustomer.id, customerContractData.id));
      await dispatch<any>(CreditsActions.setSelectedCustomerContract({}));
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_CUSTOMER_CONTRACT_MODAL'));
      await this.onFetchCustomerContracts(0, rowsPerPage);
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      await dispatch<any>(CreditsActions.setSelectedCustomerContract({}));
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_CUSTOMER_CONTRACT_MODAL'));
      dispatch<any>(ModalsActions.showModal(`ERROR_CUSTOMER_CONTRACT_CREATION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'credits.deleteCustomerContractError',
        }
      }));
    }
  }

  public async onRowClick(customerContract: ICustomerContractInDTO) {
    const { dispatch } = this.props;
    try {
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      const customer = await dispatch<any>(CreditsActions.fetchCustomerDetails(customerContract.customerId));
      await dispatch<any>(CreditsActions.setSelecteCustomer(customer));
      await dispatch<any>(CreditsActions.setSelectedCustomerContract(customerContract));
      if (AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CONTRACT_SERVICES_READ)) {
        await dispatch<any>(CreditsActions.fetchCustomerContractServices({pageSize: 200, customerId: customer.id, contractId: customerContract.id }));
      }
      if (AbilityProvider.getAbilityHelper().hasPermission(PERMISSIONS.CUSTOMER_PLANTS_READ)) {
        await dispatch<any>(CreditsActions.fetchCustomerPlants({pageSize: 200, customerId: customer.id }));
      }
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`OPERATIONAL_CUSTOMER_CONTRACT_MODAL`, {
        modalType: ModalTypes.OPERATIONAL_VIEW_MODAL,
        modalProps: {
          onClose: () => dispatch<any>(CreditsActions.setSelectedCustomerContract({})),
          overflowDisabled: true,
          content: (
            <CustomerContractDetailsView
              onDeleteCustomerContractRequest={(customerContract) => {this.onDeleteCustomerContractRequest(customerContract)}}
            />
          ),
          titleMessageKey: 'credits.customerContractDetails',
        }
      }));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_CUSTOMER_CONTRACT_DETAILS`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.getCustomerContractDetailsError',
        }
      }));
    }
  }

  async exportXLSX() {
    const { dispatch } = this.props;
    const { filters } = this.state;
    dispatch<any>(SettingsActions.setSpinnerVisible(true));
    try {
      const [contractsResponse, servicesResponse] = await Promise.all([
        dispatch<any>(CreditsActions.fetchAllCustomerContracts({ page: 0, pageSize: 10000, doNotSave: true, ...filters })),
        dispatch<any>(CreditsActions.fetchAllCustomerContractServices({ page: 0, pageSize: 10000, doNotSave: true })),
      ]);

      const contracts: ICustomerContractInDTO[] = (contractsResponse && contractsResponse.content) || [];
      const allServices: ICustomerContractServiceInDTO[] = (servicesResponse && servicesResponse.content) || [];
      const servicesByContract = _.groupBy(allServices, 'customerContractId');

      const contractHeader = [
        'Type',
        'Contract Name',
        'Customer Name',
        'Customer ID',
        'Contract Status',
        'Signing Date',
        'Activation Date',
        'Deactivation Date',
        'Expiration Date',
        'Plants',
      ];

      const serviceHeader = [
        'SERVICE',
        'Service Code',
        'Service Subject',
        'Service Group Family',
        'Service Type',
        'SFDC ID',
        'Sell-out PO Number',
        'Service Status',
        'Service Activation Date',
        'Service Deactivation Date',
        'Price',
        'Currency',
        'Quantity',
        'Net Price',
        'Total Invoiced',
      ];

      const rows: (string | number)[][] = [contractHeader];
      const formatDate = (value?: number) => (value ? moment(value).format('DD/MM/YYYY') : '');

      _.forEach(contracts, (contract) => {
        rows.push([
          'CONTRACT',
          contract.name || '',
          contract.customerName || '',
          contract.customerId != null ? String(contract.customerId) : '',
          contract.status ? translations.t(`credits.customerContractStatus_${contract.status}`).toUpperCase() : '',
          formatDate(contract.signingDate),
          formatDate(contract.activationDate),
          formatDate(contract.deactivationDate),
          formatDate(contract.expirationDate),
          contract.plants && contract.plants.length > 0 ? contract.plants.map(plant => plant.hostname).join(', ') : '',
        ]);

        const contractServices = servicesByContract[contract.id] || [];
        if (contractServices.length > 0) {
          rows.push(serviceHeader);
          _.forEach(contractServices, (service) => {
            rows.push([
              '',
              service.code || '',
              service.subject || '',
              service.groupFamily || '',
              service.type || '',
              service.sfdcId || 'N/A',
              service.sellOutPONumber || '',
              service.status ? translations.t(`credits.customerContractServiceStatus_${service.status}`).toUpperCase() : '',
              formatDate(service.activationDate),
              formatDate(service.deactivationDate),
              service.price != null ? service.price : '',
              service.currency || '',
              service.quantity != null ? service.quantity : '',
              service.netPrice != null ? service.netPrice : '',
              service.netPrice != null && service.quantity != null ? service.netPrice * service.quantity : '',
            ]);
          });
        }

        rows.push([]);
      });

      const ws = XLSX.utils.aoa_to_sheet(rows);
      ws['!cols'] = [
        { wch: 10 }, { wch: 24 }, { wch: 24 }, { wch: 12 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 14 }, { wch: 28 },
        { wch: 14 }, { wch: 14 }, { wch: 18 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 12 }, { wch: 14 },
      ];

      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      const wb = { Sheets: { Contracts: ws }, SheetNames: ['Contracts'] };
      const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
      FileSaver.saveAs(new Blob([excelBuffer], { type: fileType }), `customer-contracts-${moment().toISOString()}.xlsx`);

      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_CUSTOMER_CONTRACTS_EXPORT`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.exportCustomerContractsError',
        }
      }));
    }
  }

  public async handleChangeRowsPerPage(pageSize: number) {
    this.setState({ rowsPerPage: pageSize, isLoading: true }, async () => {
      this.onFetchCustomerContracts(0, pageSize);
    });
  }

  onSearchCustomerContracts(searchValues: ICustomerContractSearchDTO) {
    const { rowsPerPage } = this.state;
    const formattedFilters = _.omitBy(searchValues, filter => filter === '' || filter === null);
    this.setState({ filters: { ...formattedFilters } }, async () => {
      this.onFetchCustomerContracts(0, rowsPerPage);
    });
    
  }

  onResetSearch() {
    const { dispatch } = this.props;
    const { rowsPerPage } = this.state;
    this.setState({
      filters: {
        search: '',
        status: undefined,
      },
    }, async () => {
      await this.onFetchCustomerContracts(0, rowsPerPage);
      dispatch<any>(CreditsActions.fetchAllCustomerContractServices({ page: 0, pageSize: 10000 }))
    })
  }

  onCustomerClick(customerId: number) {
    const { history } = this.props
    history.push(`/customers?customerId=${customerId}`);
  }

  async onPlantClick(plant: any, customerId: number) {
    const { dispatch } = this.props;
    try {
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      const customer = await dispatch<any>(CreditsActions.fetchCustomerDetails(customerId));
      if (plant.walletId) {
        const wallets = await dispatch<any>(CreditsActions.fetchCustomerWallets({pageSize: 200, customerId: customerId }));
        const wallet = wallets.content.find(wallet => wallet.id === plant.walletId);
        if (wallet) {
          this.onShowWalletDetails(wallet);
        }
        return
      } 
      this.onOpenEditCustomerPlantForm(plant, customer)
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    }
    catch (error) {
      console.log(error)
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    }
  }

  async onOpenEditCustomerPlantForm(customerPlant: IDomainInDTO, customer: ICustomerInDTO) {
    const { dispatch } = this.props;
    if (customerPlant.solution === 'LUCKEY' && customerPlant.management === 'SAAS')
      return;
    const customerDomainFormData = CustomerPlantDecoder.decodeCustomerPlantContentToForm(customerPlant);
    customerDomainFormData.customerId = customerDomainFormData.customerId || customer.id
    dispatch<any>(ModalsActions.showModal(`OPERATIONAL_CUSTOMER_DOMAIN_MODAL`, {
      modalType: ModalTypes.OPERATIONAL_VIEW_MODAL,
      modalProps: {
        content: (
          <CustomerPlantForm
            customerId={customerDomainFormData.customerId}
            customerPlant={customerDomainFormData}
            onCreateEditCustomerPlant={(newCustomerPlantData: ICustomerDomainFormDTO) => this.onEditCustomerPlantRequest(customerPlant.id, newCustomerPlantData)}
          />
        ),
        titleMessageKey: 'credits.customerDomainFormTitle',
      }
    }));
  }

  public onEditCustomerPlantRequest(customerDomainId: number, newCustomerDomainData: ICustomerDomainFormDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`CREATE_CUSTOMER_DOMAIN_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'credits.editCustomerDomain',
        successMessageKey: 'credits.editCustomerDomainConfirm',
        confirmMessageKey: 'forms.confirm',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.onEditCustomerPlantConfirm(customerDomainId, newCustomerDomainData),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`CREATE_CUSTOMER_DOMAIN_CONFIRM_MODAL`)),
      }
    }));
  }

  public async onEditCustomerPlantConfirm(customerDomainId: number, newCustomerDomainData: ICustomerDomainFormDTO) {
    const { dispatch } = this.props;
    const { rowsPerPage } = this.state;
    try {
      dispatch<any>(ModalsActions.hideModal(`CREATE_CUSTOMER_DOMAIN_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      const newCustomerDomainDataEncoded = CustomerPlantDecoder.encodeCustomerPlantFromForm(newCustomerDomainData);
      const customerDomainUpdated = await dispatch<any>(CreditsActions.editCustomerPlant(customerDomainId, newCustomerDomainDataEncoded));
      dispatch<any>(ModalsActions.hideModal(`OPERATIONAL_CUSTOMER_DOMAIN_MODAL`));
      dispatch<any>(CreditsActions.setSelectedCustomerPlant(customerDomainUpdated));
      await this.onFetchCustomerContracts(0, rowsPerPage);
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      console.log(error)
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_CUSTOMER_DOMAIN_CREATION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'credits.createCustomerDomainError',
        }
      }));
    }
  }

  public async onShowWalletDetails(wallet: IWalletInDTO) {
    const { dispatch } = this.props;
    try {
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      await this.onSelectWallet(wallet)
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`OPERATIONAL_DOMAIN_MODAL`, {
        modalType: ModalTypes.OPERATIONAL_VIEW_MODAL,
        modalProps: {
          onClose: () => dispatch<any>(CreditsActions.setSelecteWallet({})),
          overflowDisabled: true,
          content: (
            <WalletDetailsPage
              onEditWallet={(wallet) => this.editWallet(wallet)}
              onDeleteWalletRequest={(wallet) => this.onDeleteWalletRequest(wallet)}
            />
          ),
          titleMessageKey: 'credits.walletDetails',
        }
      }));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_WALLET_DETAILS`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.getWalletDetailsError',
        }
      }));
    }
  }

  editWallet(wallet: IWalletDetailedDTO) {
    this.onOpenWalletForm(wallet);
  }

  public async onOpenWalletForm(wallet?: IWalletDetailedDTO) {
    const { dispatch } = this.props;
    try {
      await dispatch<any>(ActivationActions.fetchKams({ page: 0, pageSize: 500 }));
    } catch (error) {}
    dispatch<any>(ModalsActions.showModal(`OPERATIONAL_WALLET_FORM_MODAL`, {
      modalType: ModalTypes.OPERATIONAL_VIEW_MODAL_BACKDROP,
      modalProps: {
        content: (
          <WalletForm
            wallet={wallet}
            onCreateNewWallet={walletData => wallet ? this.editWalletRequest(wallet.id, walletData) : this.onCreateNewWalletRequest(walletData) }
          />
        ),
        titleMessageKey: 'forms.createNewWallet',
      }
    }));
  }

  public onCreateNewWalletRequest(walletData: IWalletFormDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`CREATE_CUSTOMER_WALLET_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'credits.newWallet',
        successMessageKey: 'credits.walletCreationConfirm',
        confirmMessageKey: 'credits.createWallet',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.onCreateNewWalletConfirm(walletData),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`CREATE_CUSTOMER_WALLET_CONFIRM_MODAL`)),
      }
    }));
  }

  public async onCreateNewWalletConfirm(walletData: IWalletFormDTO) {
    const { dispatch, selectedCustomer } = this.props;
    try {
      dispatch<any>(ModalsActions.hideModal(`CREATE_CUSTOMER_WALLET_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      await dispatch<any>(CreditsActions.createNewCustomerWallet(selectedCustomer.id, walletData));
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_WALLET_FORM_MODAL'));
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_WALLET_CREATION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.createCustomerWalletError',
        }
      }));
    }
  }

  async onSelectWallet(wallet: IWalletInDTO) {
    const { dispatch } = this.props;
    await dispatch<any>(CreditsActions.setSelecteWallet(wallet));
    await dispatch<any>(CreditsActions.fetchCustomerWalletSubscriptions({ walletId: wallet.id, page: 0, pageSize: 200 }));
    await dispatch<any>(CreditsActions.fetchCustomerWalletCredits({ walletId: wallet.id, page: 0, orderDir: IOrderDirectionEnum.DESC, pageSize: 50 }));
    await dispatch<any>(CreditsActions.fetchCustomerWalletPlants({ walletId: wallet.id, page: 0, pageSize: 50 }));
    await dispatch<any>(CreditsActions.fetchCustomerWalletUsage({ walletId: wallet.id, page: 0, orderDir: IOrderDirectionEnum.DESC, pageSize: 50 }));
    await dispatch<any>(CreditsActions.fetchCustomerWalletAvailableCredits(wallet.id));
  }

  public editWalletRequest(walletId: number, walletData: IWalletFormDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`EDIT_CUSTOMER_WALLET_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'credits.editWallet',
        successMessageKey: 'credits.walletEditConfirm',
        confirmMessageKey: 'credits.editWallet',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.editWalletConfirm(walletId, walletData),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`EDIT_CUSTOMER_WALLET_CONFIRM_MODAL`)),
      }
    }));
  }

  async editWalletConfirm(walletId: number, walletData: IWalletFormDTO) {
    const { dispatch } = this.props;
    try {
      dispatch<any>(ModalsActions.hideModal(`EDIT_CUSTOMER_WALLET_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      const walletUpdated = await dispatch<any>(CreditsActions.editCustomerWallet(walletId, walletData));
      await this.onSelectWallet(walletUpdated)
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_WALLET_FORM_MODAL'));
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_WALLET_CREATION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.editCustomerWalletError',
        }
      }));
    }
  }

  public onDeleteWalletRequest(wallet: IWalletDetailedDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`DELETE_WALLET_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'domains.walletDeletionTitle',
        successMessageKey: 'domains.walletDeletionConfirm',
        confirmMessageKey: 'domains.sendDeletionRequest',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.onDeleteWalletConfirm(wallet),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`DELETE_WALLET_CONFIRM_MODAL`)),
      }
    }));
  }

  public async onDeleteWalletConfirm(wallet: IWalletDetailedDTO) {
    const { dispatch } = this.props;
    try {
      const walletName = wallet.name
      const walletId = wallet.id
      dispatch<any>(ModalsActions.hideModal(`DELETE_WALLET_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      await dispatch<any>(UserActions.openCloseWalletTicket(walletId,walletName));
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_DOMAIN_MODAL'));
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`SUCCESS_MODAL`, {
        modalType: ModalTypes.SUCCESS_MODAL,
        modalProps: {
          titleMessageKey: 'domains.walletDeletionSuccess',
        }
      }));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_WALLET_DELETION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.deleteWalletRequestError',
        }
      }));
    }
  }
  
  async onOpenNewCustomerContractForm() {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`OPERATIONAL_CREATE_CUSTOMER_CONTRACT_MODAL`, {
      modalType: ModalTypes.OPERATIONAL_VIEW_MODAL_BACKDROP,
      modalProps: {
        content: (
          <CustomerContractForm
            onCreateEditCustomerContract={(newCustomerContractData: ICustomerContractFormDTO) => this.onCreateNewCustomerContractRequest(newCustomerContractData)}
          />
        ),
        titleMessageKey: 'forms.customerContractFormTitle',
      }
    }));
  }

  public onCreateNewCustomerContractRequest(newCustomerContractData: ICustomerContractFormDTO) {
    const { dispatch } = this.props;
    dispatch<any>(ModalsActions.showModal(`CREATE_CUSTOMER_CONTRACT_CONFIRM_MODAL`, {
      modalType: ModalTypes.CONFIRM_MODAL,
      modalProps: {
        icon: <WarningIcon style={{ color: 'orange', fontSize: 50 }} />,
        titleMessageKey: 'credits.newCustomerContract',
        successMessageKey: 'credits.customerContractCreationConfirm',
        confirmMessageKey: 'forms.confirm',
        cancelMessageKey: 'forms.cancel',
        onConfirm: () => this.onCreateNewCustomerContractConfirm(newCustomerContractData),
        onCancel: () => dispatch<any>(ModalsActions.hideModal(`CREATE_CUSTOMER_CONTRACT_CONFIRM_MODAL`)),
      }
    }));
  }

  public async onCreateNewCustomerContractConfirm(newCustomerContractData: ICustomerContractFormDTO) {
    const { dispatch } = this.props;
    const { rowsPerPage } = this.state;
    try {
      dispatch<any>(ModalsActions.hideModal(`CREATE_CUSTOMER_CONTRACT_CONFIRM_MODAL`));
      dispatch<any>(SettingsActions.setSpinnerVisible(true));
      const newContract = await dispatch<any>(CreditsActions.createNewCustomerContract(newCustomerContractData.customer.id, newCustomerContractData));
      await this.onFetchCustomerContracts(0, rowsPerPage);
      dispatch<any>(ModalsActions.hideModal('OPERATIONAL_CREATE_CUSTOMER_CONTRACT_MODAL'));
      if (newContract)
        this.onRowClick(newContract)
      else
        dispatch<any>(SettingsActions.setSpinnerVisible(false));
    } catch (error) {
      dispatch<any>(SettingsActions.setSpinnerVisible(false));
      dispatch<any>(ModalsActions.showModal(`ERROR_CUSTOMER_CONTRACT_CREATION`, {
        modalType: ModalTypes.ERROR_MODAL,
        modalProps: {
          titleMessageKey: 'errors.error',
          errorMessageKey: 'errors.createCustomerContractError',
        }
      }));
    }
  }

  async onFetchCustomersFormSearch(value: string) {
    const { dispatch } = this.props;
    const params: ICustomerRequestParamsDTO = { page: 0, pageSize: 200,   name: value };
    const customers = await dispatch<any>(CreditsActions.fetchCustomers(params));
    if (customers && customers.content) {  
      const customersOptions = getCustomersOptions(customers.content);
      this.setState({ customersOptions });
    }
  }



  render() {
    const { rowsPerPage, customersOptions } = this.state;
    const { classes, customerContracts, customerContractServices } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.header}>
          <CustomerContractsSearchBar 
            onSearch={(values: ICustomerContractSearchDTO) => this.onSearchCustomerContracts(values)}
            onResetSearch={() => this.onResetSearch()}
            onFilterCustomers={(value: string) => this.onFetchCustomersFormSearch(value)}
            customersOptions={customersOptions}
            onCreateNewEntityButtonClick={() => this.onOpenNewCustomerContractForm()}
          />
          <div style={{ display: 'flex', flexDirection: 'row'}}>
            <Button
              variant="contained"
              style={{ backgroundColor: 'cornflowerblue', color: 'white', fontSize: 10, marginLeft: 10, fontWeight: 'bold'  }}
              onClick={() => this.exportXLSX()}
            >
              <ReduxLanguage languageKey="credits.exportCustomerContractsXLSX" />
            </Button>
          </div>
        </div>
        <div className={classes.tableContainer}>
          <CustomerContractsTable
            rowsPerPage={rowsPerPage}
            customerContracts={customerContracts as PaginatedDataDTO<ICustomerContractInDTO>}
            onRowClick={(customerContract) => {this.onRowClick(customerContract)}}
            onPageSizeChange={pageSize => this.handleChangeRowsPerPage(pageSize)}
            onFetchElementsOnPage={page => this.onFetchCustomerContracts(page, rowsPerPage)}
            customerAllContractServices={(customerContractServices as PaginatedDataDTO<ICustomerContractServiceInDTO>).content || []}
            showCustomer={true}
            onCustomerClick={(customerId: number) => this.onCustomerClick(customerId)}
            onPlantClick={(plant: any, customerId: number) => this.onPlantClick(plant, customerId)}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state: IState) {
  return {
    language: state.settings.language,
    selectedCustomer: state.credits.customers.selectedDetailedCustomer,
    customerContracts: state.credits.allCustomerContracts.data,
    customerContractServices: state.credits.allCustomerContractServices.data,
    allCustomers: state.credits.allCustomers.data,
  };
}

const connector = connect(mapStateToProps);

export default connector(withRouter(withStyles(styles)(CustomerContractsPage)));